import React, { Component } from 'react';
import SearchField from '../search-field';
import { Icon } from '../asset/asset.type';
import { translatableText } from '../../utils/translatable-text';
import './global-hero.less';

interface Props {
    wrapperClassName?: string;
    title: string;
    primaryImage: Icon;
    secondaryImage: Icon;
}

export default class GlobalHero extends Component<Props> {
    render() {
        const {
            wrapperClassName,
            title,
            primaryImage,
            secondaryImage
        } = this.props;

        return (
            <section className={['global-hero', wrapperClassName].join(' ')}>
                <div className="global-hero__inner">
                    <div className="global-hero__top">
                        <h1
                            data-testid="hero_headline"
                            className="global-hero__headline"
                        >
                            {title}
                        </h1>
                        <p className="global-hero__headline--secondary margin-top-medium">
                            {translatableText.globalHeroHeadline.text}
                        </p>
                        <SearchField className="search margin-top-medium" />
                    </div>
                    <div className="global-hero__bottom">
                        <img
                            className="global-hero__img global-hero__img--book-people"
                            src={primaryImage.url}
                            alt="Global Hero Book People"
                        />
                        <img
                            className="global-hero__img global-hero__img--small-people"
                            src={secondaryImage.url}
                            alt="Global Hero Small People"
                        />
                    </div>
                </div>
            </section>
        );
    }
}
